'use client'

import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { useEffect, useState } from 'react'

import ButtonLink from 'components/ButtonLink'
import Page from 'components/Page'
import ROUTES from 'config/routes.json'
import ProductGameTile from 'containers/ProductGameTile'
import content from 'prismic-translates/common.json'
import Loader from 'src/components/Loader'
import { setTopGames } from 'utils/loadGameInfoGetInitialProps'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])
const COUNT_GAMES = 4

export default function GameBlockedByLocation() {
  const [isLoading, setIsLoading] = useState(true)
  const [games, setGames] = useState<GameProduct[]>([])
  const [layout, setLayout] = useState<string>('')

  const isGamesAvailable = games.length > 0

  useEffect(() => {
    if (isLoading) {
      setTopGames(COUNT_GAMES, setIsLoading, setGames, setLayout)
    }
  }, [isLoading])

  return (
    <Page className={classes.classNameRoot}>
      <div className={classes.root}>
        <div className={classes.content}>
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <img
                className={classes.locationImage}
                src={`${process.env.IMG_ORIGIN}/not_available_location.svg`}
                alt='not available location'
              />
              <h3 className={classes.title}>{t('game_not_available_in_location')}</h3>
              {isGamesAvailable && (
                <>
                  <h4 className={classes.description}>{t('play_other_exciting_games')}</h4>
                  <div className={classes.games}>
                    {games.map((game, index) => (
                      <ProductGameTile
                        game={game}
                        key={game.code}
                        gameIndex={index + 1}
                        refererPath='restrictedPopup'
                        layout={layout}
                      />
                    ))}
                  </div>
                </>
              )}
              <ButtonLink className={classes.btn} variant='contained' href={ROUTES.HOME}>
                {t('go_to_home_btn')}
              </ButtonLink>
            </>
          )}
        </div>
      </div>
    </Page>
  )
}
